import React, {Component} from 'react';
import {DATE_TIME_FORMAT} from '../../components/helpers/DateHelper';
import moment from 'moment';
import DateTimePicker from "../common/DateTimePicker";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class ServiceDate extends React.Component {
    constructor(props) {
        super(props);
    }

    renderError(type) {
        if (this.canShowError(type)) {
            return (
                <div className={'form-control-feedback error-block'}>
                    {this.props[type].meta.error}
                </div>
            );
        }
        return null;
    }

    canShowError(type) {
        if (this.props.isUpdate) {
            return this.props[type].meta.error
        }
        return this.props[type].meta.error && this.props[type].meta.touched;
    }

    applyErrorClass(type) {
        return this.canShowError(type) ? 'has-danger' : '';
    }

    render() {
        let {
            startDate: {
                input: startDateInput,
                input: {
                    value: startDate
                }
            },
            endDate: {
                input: endDateInput,
                input: {
                    value: endDate
                }
            },
            intl
        } = this.props;
        return (
            <div>
                <div className={`form-group row ${this.applyErrorClass('startDate')}`}>
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.publishedAt)}</b>
                    </label>
                    <div className="col-sm-10 p-0">
                        <DateTimePicker
                            value={startDate ? moment(startDate, DATE_TIME_FORMAT) : moment()}
                            formInput={startDateInput}
                        />
                        <small className="text-muted p-l-10">(dd-mm-åååå tt:mm)</small>
                        {this.renderError('startDate')}
                    </div>
                </div>
                <div className={`form-group row ${this.applyErrorClass('endDate')}`}>
                    <label className="col-sm-2 col-form-label">
                        <b>{intl.formatMessage(messages.expires)}</b>
                    </label>
                    <div className="col-sm-10 p-0">
                        <DateTimePicker
                            value={endDate ? moment(endDate, DATE_TIME_FORMAT) : moment()}
                            minDate={startDate ? moment(startDate, DATE_TIME_FORMAT) : moment()}
                            formInput={endDateInput}
                        />
                        <small className="text-muted p-l-10">(dd-mm-åååå tt:mm)</small>
                        {this.renderError('endDate')}
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(ServiceDate);



// WEBPACK FOOTER //
// ./web/src/components/services/ServiceDate.jsx